export default function flagsContext(key) {
	return flags[key];
}

const flags = {
	'./australia': require('./australia.svg'),
	'./canada': require('./canada.svg'),
	'./europe': require('./europe.svg'),
	'./france': require('./france.svg'),
	'./germany': require('./germany.svg'),
	'./hongkong': require('./hongkong.svg'),
	'./japan': require('./japan.svg'),
	'./mexico': require('./mexico.png'),
	'./uk': require('./uk.svg'),
	'./usa': require('./usa.svg')
};



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/images/flag/index.js